import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { TextSkeleton as t } from "../../../components/TextSkeleton/index.js";
import { HotDealContainer as r, HotDealImageSkeleton as n, InfoList as d, InfoListItem as o, CardBody as l, HotDealTitleSkeleton as h } from "./style.js";
function p() {
  return /* @__PURE__ */ i(r, { children: [
    /* @__PURE__ */ e(n, {}),
    /* @__PURE__ */ i(d, { children: [
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(t, { width: "50px" }) }),
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(t, { width: "30px" }) }),
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(t, { width: "50px" }) })
    ] }),
    /* @__PURE__ */ i(l, { children: [
      /* @__PURE__ */ i(h, { children: [
        /* @__PURE__ */ e(t, { width: "100%" }),
        /* @__PURE__ */ e("br", {}),
        /* @__PURE__ */ e(t, { width: "80%" })
      ] }),
      /* @__PURE__ */ e(t, { width: "58px" })
    ] })
  ] });
}
export {
  p as HotDealCardSkeleton
};
